import { all } from "redux-saga/effects"
import watchForNotifications from "./watchForNotificationsSaga"

export default function* () {
  yield all([watchForNotifications()])
}
